import { Form, Radio } from "semantic-ui-react";
import { PermitFieldValueInput } from "../../models/globalTypes";
import { BooleanTemplateField } from "../../models/TemplateField";

interface Props {
  field: BooleanTemplateField;
  value: PermitFieldValueInput | undefined;
  onChange: (fieldKey: string, update: Partial<PermitFieldValueInput>) => void;
  disabled: boolean;
  error: string | undefined;
  required?: boolean;
}

const BooleanFieldInput = ({ field, value, onChange, disabled, error, required }: Props) => {
  const currentValue = value?.booleanValue !== undefined ? value.booleanValue : (field.defaultValue ?? undefined);

  return (
    <Form.Field required={required} error={!!error} disabled={disabled}>
      <label>{field.label}</label>
      <div role="radiogroup" style={{ display: "flex", gap: 16 }}>
        <Radio
          label={field.trueLabel || "Yes"}
          checked={currentValue === true}
          disabled={disabled}
          onChange={() => onChange(field.key, { booleanValue: true })}
        />
        <Radio
          label={field.falseLabel || "No"}
          checked={currentValue === false}
          disabled={disabled}
          onChange={() => onChange(field.key, { booleanValue: false })}
        />
      </div>
      {error && <div className="ui pointing above prompt label">{error}</div>}
    </Form.Field>
  );
};

export default BooleanFieldInput;
